import {guardarDoc} from "../BD/guardarDoc";

export const guardarFecha = async (fecha) => {

    let obj = {
        fecha: fecha ? fecha : new Date().getTime(),
        id: 'fecha'
    }
    console.log(obj)

    await guardarDoc('actualizaciones', obj)


}